/**
 * The glass surface the two cards of the assessment tab's first row share -- the score dial and the
 * performance trend. Declared once so the pair cannot drift apart, and so one line takes it back.
 *
 * The radius is the drawing's 30px, which falls between `rounded-3xl` and `rounded-4xl`; the
 * padding is the `p-8` step spelt out beside it.
 */
export const HEADLINE_CARD_SURFACE = 'w-full !rounded-[30px] !p-[32px] backdrop-blur-[10px]';

/** The heading both cards of that row carry. */
export const HEADLINE_CARD_TITLE =
    'text-font-xl ds-mb-xl text-navy text-center leading-[25px] font-medium';
